<template>
    <div class="mt-3">
        <button
            class="btn btn-success"
            v-if="noBack.indexOf(tab) < 0"
            @click="sendEvent('BACK_EMIT_TO_PARENT')"
        >
            Zurück
        </button>
        <button
            class="btn btn-success float-right"
            v-if="noWeiter.indexOf(tab) < 0"
            @click="sendEvent('NEXT_EMIT_TO_PARENT')"
        >
            Weiter
        </button>
    </div>
</template>

<script>
    import EventBus from '../../EventBus'
    export default {
        data() {
            return {
                noBack: [
                    'packet_choice',
                    'payment'
                ],
                noWeiter: [
                    'payment'
                ]
            }
        },
        props: ['tab', 'addNoBack'],
        watch: {
            addNoBack(val) {
                val.forEach(item => {
                    this.noBack.push(item);
                });
            }
        },
        methods: {
            sendEvent(action) {
                EventBus.$emit(action);
            }
        },
        created() {
            this.addNoBack.forEach(item => {
                this.noBack.push(item);
            });
        }
    }
</script>

<style scoped>
div{
    overflow: auto;
}
</style>
